<!-- a switch announces on/off. A switch has no "mixed" value, so the neutral (not answered)
     state is announced as a partially checked checkbox instead of a false "off" -->
<button cs-capture-cover (click)="handleClick($event)" [attr.aria-label]="ariaLabel || null"
[attr.role]="checked === null ? 'checkbox' : 'switch'"
[attr.aria-checked]="checked === null ? 'mixed' : (checked ? 'true' : 'false')">
</button>
<div class="toggle-track">
  <div class="toggle-thumb"></div>
</div>